import React from "react";

// Loading placeholder: a responsive grid of shimmering blocks (variant "card")
// or stacked rows (variant "row"). Announced once as a busy status region.
export default function TspSkeleton({ count = 6, variant = "card", label = "Loading" }) {
  return (
    <div className={`tsp-skeleton-wrap tsp-skeleton-${variant}`} role="status" aria-busy="true" aria-label={label}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="tsp-skeleton" />
      ))}
    </div>
  );
}
